import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';

import WithdrawFromPurchaseComponent from '../components/withdraw-from-purchase/index';
import {
  getCurrentUserMembership,
} from '../selectors/purchase-selector';
import {
  withdrawFromPurchase,
  removeMembership,
  hideWithdrawModal,
  showAlert,

  ALERT_WITHDRAW_FROM_PURCHASE
} from '../actions';
import Membership from '../lib/membership';

import withDashboardProjectionFetcher from '../../components/hoc/with-dashboard-projection-fetcher';

class WithdrawFromPurchase extends Component {
  constructor(props) {
    super(props);
    this.onSubmit = this.onSubmit.bind(this);
    this.onStayInGroup = this.onStayInGroup.bind(this);
  }

  onSubmit(props) {
    if (props.remove) return this.removeMembership();
    return this.withdrawMembership();
  }

  onStayInGroup() {
    this.props.actions.hideWithdrawModal();
  }

  withdrawMembership() {
    const { purchaseId, authentication, actions } = this.props;
    const { withdrawFromPurchase, showAlert } = actions;

    return withdrawFromPurchase(purchaseId, authentication)
      .then(() => {
        showAlert(ALERT_WITHDRAW_FROM_PURCHASE);
        this.onSubmitSuccess();
      });
  }

  removeMembership() {
    const { membership, authentication } = this.props;
    return this.props.actions.removeMembership(membership.id, authentication)
      .then(() => this.onSubmitSuccess());
  }

  onSubmitSuccess() {
    const { actions, fetchDashboardProjection } = this.props;
    const { hideWithdrawModal } = actions;

    fetchDashboardProjection();
    hideWithdrawModal();
  }

  render() {
    return (
      <WithdrawFromPurchaseComponent
        onSubmit={this.onSubmit}
        onStayInGroup={this.onStayInGroup}

        purchaseName={this.props.purchaseName}
        isOrganizer={this.props.isOrganizer}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const purchase = state.purchases.byId[state.purchases.current];
  const membership = getCurrentUserMembership(state);

  return {
    purchaseId: purchase.id,
    purchaseSlug: purchase.slug,
    purchaseName: purchase.product.name,
    membership,
    authentication: state.session.authentication,
    isOrganizer: membership && Membership.isOrganizer(membership.role),
  };
};

const mapDispatchToProps = (dispatch) => {
  const containerActions = {
    withdrawFromPurchase,
    removeMembership,
    hideWithdrawModal,
    showAlert
  };

  return {
    actions: bindActionCreators(containerActions, dispatch),
  };
};

export default compose(
  withDashboardProjectionFetcher,
  connect(mapStateToProps, mapDispatchToProps)
)(WithdrawFromPurchase);



// WEBPACK FOOTER //
// ./src/desktop/containers/withdraw-from-purchase.container.js